/* Recherche : suggestions prédictives pendant la frappe, bouton d'effacement, navigation au clavier.
   Source de données : API de rendu de sections de Shopify (/search/suggest?section_id=mi-predictive-search) ; aucune application, aucune donnée enregistrée.
   Sans JavaScript, le formulaire envoie la recherche à /search (résultats côté serveur). Maquette : js/recherche.js. */
const DELAY = 160;

function bind(root) {
  if (root.dataset.miInit) return;
  root.dataset.miInit = '1';
  const input = root.querySelector('[data-rc-input]');
  const box = root.querySelector('[data-rc-predictive]');
  const clear = root.querySelector('[data-rc-clear]');
  const form = root.querySelector('[data-rc-form]');
  if (!input || !box || !form) return;
  const base = root.dataset.predictiveUrl || '/search/suggest';
  const sectionId = root.dataset.predictiveSection || 'mi-predictive-search';
  let timer = 0; let ctrl = null; let seq = 0;

  const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); };
  const open = () => { box.hidden = false; input.setAttribute('aria-expanded', 'true'); };

  async function suggest(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const mine = ++seq;
    const url = `${base}?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,body,tag&section_id=${encodeURIComponent(sectionId)}`;
    try {
      const res = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(String(res.status));
      const html = await res.text();
      if (mine !== seq) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.rc-pred__in');
      if (!inner) { close(); return; }
      box.innerHTML = '';
      box.appendChild(document.importNode(inner, true));
      open();
    } catch (e) {
      if (e.name !== 'AbortError') close();   // repli : l'envoi du formulaire reste disponible
    }
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (clear) clear.hidden = !input.value;
    clearTimeout(timer);
    if (q.length < 2) { close(); return; }
    timer = setTimeout(() => suggest(q), DELAY);
  });
  if (clear) clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; close(); input.focus(); });
  input.addEventListener('keydown', (e) => {
    const items = [...box.querySelectorAll('.rc-pred__item')];
    if (e.key === 'Escape') { close(); return; }
    if (box.hidden || !items.length) return;
    const i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
  });
  box.addEventListener('keydown', (e) => {
    const items = [...box.querySelectorAll('.rc-pred__item')];
    const i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' && i > -1) { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
    if (e.key === 'Escape') { close(); input.focus(); }
  });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  form.addEventListener('focusout', (e) => { if (!form.contains(e.relatedTarget)) setTimeout(() => { if (!form.contains(document.activeElement)) close(); }, 0); });
}
const init = (scope = document) => scope.querySelectorAll('[data-rc]').forEach(bind);
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
